(function () {
  const MODAL_ID = 'ProductWishlistModal';
  const TRIGGER_SELECTOR = '#custom-wishlist-button';
  const SHOPPER_READY_KEY = 'poubel_wishlist_shopper_ready';
  const SHOPPER_EMAIL_KEY = 'poubel_wishlist_shopper_email';
  const KLAVIYO_SYNCED_KEY = 'poubel_klaviyo_email_synced';
  const KLAVIYO_API_REVISION = '2026-04-15';
  const WISHLIST_HEART_OUTLINE_PATH =
    'M9.73438 2.1875C8.60508 2.1875 7.61633 2.67312 7 3.49398C6.38367 2.67312 5.39492 2.1875 4.26562 2.1875C3.36669 2.18851 2.50486 2.54606 1.86921 3.18171C1.23356 3.81736 0.876013 4.67919 0.875 5.57812C0.875 9.40625 6.55102 12.5048 6.79273 12.6328C6.85644 12.6671 6.92766 12.685 7 12.685C7.07234 12.685 7.14356 12.6671 7.20727 12.6328C7.44898 12.5048 13.125 9.40625 13.125 5.57812C13.124 4.67919 12.7664 3.81736 12.1308 3.18171C11.4951 2.54606 10.6333 2.18851 9.73438 2.1875ZM7 11.7469C6.00141 11.165 1.75 8.5143 1.75 5.57812C1.75087 4.91121 2.01619 4.27185 2.48777 3.80027C2.95935 3.32869 3.59871 3.06337 4.26562 3.0625C5.3293 3.0625 6.22234 3.62906 6.59531 4.53906C6.62827 4.6193 6.68435 4.68794 6.7564 4.73624C6.82846 4.78454 6.91325 4.81033 7 4.81033C7.08675 4.81033 7.17154 4.78454 7.2436 4.73624C7.31565 4.68794 7.37173 4.6193 7.40469 4.53906C7.77766 3.62742 8.6707 3.0625 9.73438 3.0625C10.4013 3.06337 11.0406 3.32869 11.5122 3.80027C11.9838 4.27185 12.2491 4.91121 12.25 5.57812C12.25 8.50992 7.9975 11.1645 7 11.7469Z';
  const WISHLIST_HEART_FILLED_PATH =
    'M9.73438 2.1875C8.60508 2.1875 7.61633 2.67312 7 3.49398C6.38367 2.67312 5.39492 2.1875 4.26562 2.1875C3.36669 2.18851 2.50486 2.54606 1.86921 3.18171C1.23356 3.81736 0.876013 4.67919 0.875 5.57812C0.875 9.40625 6.55102 12.5048 6.79273 12.6328C6.85644 12.6671 6.92766 12.685 7 12.685C7.07234 12.685 7.14356 12.6671 7.20727 12.6328C7.44898 12.5048 13.125 9.40625 13.125 5.57812C13.124 4.67919 12.7664 3.81736 12.1308 3.18171C11.4951 2.54606 10.6333 2.18851 9.73438 2.1875Z';

  let swatApi = null;
  let currentWishlistAdded = false;

  function getSwat() {
    return swatApi || window._swat || null;
  }

  function getModalElements() {
    const modal = document.getElementById(MODAL_ID);
    if (!modal) return null;

    return {
      modal,
      dialog: modal.querySelector('.product-wishlist-modal__dialog'),
      form: modal.querySelector('.product-wishlist-modal__form'),
      emailInput: modal.querySelector('.product-wishlist-modal__input'),
      submitButton: modal.querySelector('.product-wishlist-modal__submit'),
      errorMessage: modal.querySelector('.product-wishlist-modal__error'),
      closeTargets: modal.querySelectorAll('[data-wishlist-modal-close]')
    };
  }

  function getCustomerId(modal) {
    if (window.swymCustomerId) return String(window.swymCustomerId);
    if (modal && modal.dataset.customerId) return String(modal.dataset.customerId);
    return null;
  }

  function getCustomerEmail(modal) {
    if (window.swymCustomerEmail) return String(window.swymCustomerEmail).trim();
    if (modal && modal.dataset.customerEmail) return String(modal.dataset.customerEmail).trim();

    try {
      return window.localStorage.getItem(SHOPPER_EMAIL_KEY) || '';
    } catch (error) {
      return '';
    }
  }

  function isCustomerLoggedIn(swat, modal) {
    if (getCustomerId(modal)) return true;

    if (swat && swat.platform && typeof swat.platform.isLoggedIn === 'function') {
      return swat.platform.isLoggedIn();
    }

    return false;
  }

  function hasGuestEmailCaptured() {
    try {
      return window.localStorage.getItem(SHOPPER_READY_KEY) === '1';
    } catch (error) {
      return false;
    }
  }

  function markGuestEmailCaptured(email) {
    try {
      window.localStorage.setItem(SHOPPER_READY_KEY, '1');
      if (email) {
        window.localStorage.setItem(SHOPPER_EMAIL_KEY, email);
      }
    } catch (error) {
      /* ignore storage errors */
    }
  }

  function shouldSkipEmailModal(swat, modal) {
    return isCustomerLoggedIn(swat, modal) || hasGuestEmailCaptured();
  }

  function syncLoggedInCustomer(swat, modal) {
    const customerId = getCustomerId(modal);
    if (!customerId || typeof swat.validateUserLogin !== 'function') return;

    swat.validateUserLogin('shopify', customerId, function onSuccess(response) {
      console.log('[Swym] validateUserLogin success — guest wishlist merged into account', {
        customerId,
        response
      });
    });
  }

  function mountModalToBody(modal) {
    if (!modal || modal.dataset.wishlistModalMounted === 'true') return;
    modal.dataset.wishlistModalMounted = 'true';
    document.body.appendChild(modal);
  }

  function openModal(elements) {
    elements.modal.hidden = false;
    elements.modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('product-wishlist-modal-open');
    elements.errorMessage.hidden = true;
    elements.errorMessage.textContent = '';

    const savedEmail = getCustomerEmail(elements.modal);
    if (savedEmail && elements.emailInput && !elements.emailInput.value) {
      elements.emailInput.value = savedEmail;
    }

    window.setTimeout(function () {
      elements.emailInput.focus();
    }, 0);
  }

  function closeModal(elements) {
    elements.modal.hidden = true;
    elements.modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('product-wishlist-modal-open');
  }

  function getSelectedVariantId(modal) {
    const variantInput = document.querySelector('.product-form input.product-variant-id');
    if (variantInput && variantInput.value) return String(variantInput.value);
    if (modal && modal.dataset.variantId) return String(modal.dataset.variantId);
    return null;
  }

  function getCanonicalProductUrl(modal) {
    if (window.location.pathname.includes('/products/')) {
      return window.location.origin + window.location.pathname.split('?')[0];
    }

    const storedUrl = modal && modal.dataset.productUrl;
    if (!storedUrl) return null;

    try {
      return window.location.origin + new URL(storedUrl, window.location.origin).pathname;
    } catch (error) {
      return storedUrl;
    }
  }

  function getProductPath(du) {
    if (!du) return null;

    try {
      return new URL(du, window.location.origin).pathname;
    } catch (error) {
      return du.startsWith('/') ? du : null;
    }
  }

  function buildProductPayload(modal, variantId, du, swymProduct) {
    const empi =
      (swymProduct && (swymProduct.empi || swymProduct.id)) ||
      Number(modal.dataset.productId);

    let epi = variantId ? Number(variantId) : null;

    if (window.SwymProductVariants && variantId) {
      const variantInfo =
        window.SwymProductVariants[String(variantId)] ||
        window.SwymProductVariants[Number(variantId)];

      if (variantInfo && variantInfo.epi) {
        epi = Number(variantInfo.epi);
      }
    }

    if (swymProduct && swymProduct.variants && variantId) {
      const variants = Array.isArray(swymProduct.variants)
        ? swymProduct.variants
        : Object.values(swymProduct.variants);

      const matchedVariant = variants.find(function (variant) {
        return String(variant.id) === String(variantId);
      });

      if (matchedVariant) {
        epi = Number(matchedVariant.id);
      }
    }

    if (!epi && swymProduct) {
      epi = Number(
        swymProduct.epi ||
          (swymProduct.variants &&
            swymProduct.variants[0] &&
            (swymProduct.variants[0].id || swymProduct.variants[0].epi))
      );
    }

    const canonicalUrl = du || getCanonicalProductUrl(modal);

    return {
      empi: Number(empi),
      epi: Number(epi),
      du: (swymProduct && swymProduct.du) || canonicalUrl,
      dt: (swymProduct && (swymProduct.dt || swymProduct.title)) || modal.dataset.productTitle,
      iu: (swymProduct && swymProduct.iu) || modal.dataset.productImage,
      source: 'pdp'
    };
  }

  function resolveProductPayload(modal, callback) {
    const swat = getSwat();
    const variantId = getSelectedVariantId(modal);
    const canonicalUrl = getCanonicalProductUrl(modal);
    const productPath = getProductPath(canonicalUrl);

    if (!variantId || !canonicalUrl) {
      callback(new Error('Product details are missing. Refresh the page and try again.'));
      return;
    }

    if (swat && typeof swat.getProductDetails === 'function' && productPath) {
      swat.getProductDetails(
        { du: productPath },
        function (swymProduct) {
          callback(null, buildProductPayload(modal, variantId, canonicalUrl, swymProduct));
        },
        function () {
          callback(null, buildProductPayload(modal, variantId, canonicalUrl, null));
        }
      );
      return;
    }

    const pageData = window.SwymPageData;
    if (pageData && pageData.et === 1) {
      callback(
        null,
        buildProductPayload(
          modal,
          variantId,
          pageData.du || canonicalUrl,
          Object.assign({}, pageData, { variants: window.SwymProductVariants })
        )
      );
      return;
    }

    callback(null, buildProductPayload(modal, variantId, canonicalUrl, null));
  }

  function setWishlistSlotReady(isReady) {
    const triggerRoot = document.querySelector(TRIGGER_SELECTOR);
    if (!triggerRoot) return;
    triggerRoot.classList.toggle('wishlist-ready', isReady);
  }

  function updateWishlistIcon(triggerRoot, isAdded) {
    if (!triggerRoot) return;

    triggerRoot
      .querySelectorAll('.product__wishlist-btn-icon path, .swym-icon path')
      .forEach(function (iconPath) {
        iconPath.setAttribute('d', isAdded ? WISHLIST_HEART_FILLED_PATH : WISHLIST_HEART_OUTLINE_PATH);
      });
  }

  function updateWishlistButtonState(isAdded) {
    currentWishlistAdded = isAdded;
    const triggerRoot = document.querySelector(TRIGGER_SELECTOR);
    if (!triggerRoot) return;

    triggerRoot
      .querySelectorAll(
        '.product__wishlist-btn, .swym-button-content button, .swym-button-content [role="button"], .swym-add-to-wishlist-view-product'
      )
      .forEach(function (button) {
        button.setAttribute('aria-pressed', isAdded ? 'true' : 'false');
        button.setAttribute('aria-label', isAdded ? 'Added' : 'Add to wishlist');
        button.classList.toggle('swym-added', isAdded);
      });

    triggerRoot.querySelectorAll('.product__wishlist-btn-text, .swym-custom-btn-txt').forEach(function (label) {
      label.textContent = isAdded ? 'Added' : 'Add to wishlist';
    });

    updateWishlistIcon(triggerRoot, isAdded);
  }

  function isProductInWishlist(items, product) {
    if (!items || !product) return false;

    return items.some(function (item) {
      return String(item.epi) === String(product.epi) && String(item.empi) === String(product.empi);
    });
  }

  function syncWishlistButtonState(modal) {
    const swat = getSwat();
    if (!swat || typeof swat.fetch !== 'function') return;

    swat.fetch(function (items) {
      resolveProductPayload(modal, function (error, product) {
        if (error || !product) return;
        updateWishlistButtonState(isProductInWishlist(items, product));
      });
    });
  }

  function addProductToWishlist(modal, onComplete) {
    const swat = getSwat();

    if (!swat) {
      onComplete(new Error('Wishlist is unavailable right now.'));
      return;
    }

    resolveProductPayload(modal, function (resolveError, product) {
      if (resolveError || !product || !product.empi || !product.epi || !product.du) {
        onComplete(resolveError || new Error('Could not load product details for wishlist.'));
        return;
      }

      if (typeof swat.fetch === 'function') {
        swat.fetch(function (items) {
          if (isProductInWishlist(items, product)) {
            updateWishlistButtonState(true);
            onComplete(null, { alreadyAdded: true });
            return;
          }

          submitAddToWishlist(swat, product, onComplete);
        });
        return;
      }

      submitAddToWishlist(swat, product, onComplete);
    });
  }

  function submitAddToWishlist(swat, product, onComplete) {
    function onSuccess(response) {
      updateWishlistButtonState(true);
      onComplete(null, response);
    }

    function onError(error) {
      onComplete(error || new Error('Could not save this item to your wishlist.'));
    }

    if (typeof swat.addToWishList === 'function') {
      swat.addToWishList(product, onSuccess, onError);
      return;
    }

    if (typeof swat.addToList === 'function' && typeof swat.fetchLists === 'function') {
      swat.fetchLists(function (lists) {
        const list = lists && lists.length ? lists[0] : null;

        if (!list || !list.lid) {
          onComplete(new Error('Could not find a wishlist to save this item.'));
          return;
        }

        swat.addToList(list.lid, product, onSuccess, onError);
      });
      return;
    }

    onComplete(new Error('Wishlist is unavailable right now.'));
  }

  function notifyWishlistChanged() {
    document.dispatchEvent(new CustomEvent('poubel:wishlist-changed'));

    if (typeof window.updateHeaderWishlistCount === 'function') {
      window.updateHeaderWishlistCount();
    }
  }

  function completeWishlistAddSuccess(elements, email) {
    if (email) {
      syncEmailToKlaviyo(email, elements.modal);
    }

    notifyWishlistChanged();

    window.setTimeout(function () {
      updateWishlistButtonState(true);
    }, 150);

    closeModal(elements);

    if (typeof window.openWishlistDrawer === 'function') {
      window.openWishlistDrawer();
    }
  }

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function callKlaviyo(method) {
    const args = Array.prototype.slice.call(arguments, 1);

    if (window.klaviyo && typeof window.klaviyo[method] === 'function') {
      window.klaviyo[method].apply(window.klaviyo, args);
      return;
    }

    window._learnq = window._learnq || [];
    window._learnq.push([method].concat(args));

    if (!window.klaviyo || Array.isArray(window.klaviyo)) {
      window.klaviyo = window.klaviyo || [];
      window.klaviyo.push([method].concat(args));
    }
  }

  function getKlaviyoConfig(modal) {
    if (!modal) return null;

    return {
      enabled: modal.dataset.klaviyoEnabled === 'true',
      publicKey: modal.dataset.klaviyoPublicKey || '',
      listId: modal.dataset.klaviyoListId || ''
    };
  }

  function buildKlaviyoWishlistProperties(modal) {
    return {
      ProductName: modal.dataset.productTitle || '',
      ProductID: modal.dataset.productId || '',
      ProductURL: modal.dataset.productUrl || '',
      ImageURL: modal.dataset.productImage || '',
      Source: 'Product Wishlist Modal'
    };
  }

  function hasKlaviyoSyncedEmail(email) {
    try {
      return window.localStorage.getItem(KLAVIYO_SYNCED_KEY) === email;
    } catch (error) {
      return false;
    }
  }

  function markKlaviyoEmailSynced(email) {
    try {
      window.localStorage.setItem(KLAVIYO_SYNCED_KEY, email);
    } catch (error) {
      /* ignore storage errors */
    }
  }

  function subscribeEmailToKlaviyoList(email, config) {
    if (!config.publicKey || !config.listId) {
      if (config.enabled) {
        console.warn(
          '[Klaviyo] Wishlist list subscription skipped. Add both public API key and list ID in Theme settings → Klaviyo Wishlist.'
        );
      }
      return Promise.resolve();
    }

    const payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Product Wishlist Modal',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                subscriptions: {
                  email: {
                    marketing: {
                      consent: 'SUBSCRIBED'
                    }
                  }
                }
              }
            }
          }
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: config.listId
            }
          }
        }
      }
    };

    return fetch(
      'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(config.publicKey),
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          revision: KLAVIYO_API_REVISION
        },
        body: JSON.stringify(payload)
      }
    )
      .then(function (response) {
        if (!response.ok) {
          return response.text().then(function (body) {
            console.warn('[Klaviyo] wishlist list subscription failed', response.status, body);
          });
        }

        markKlaviyoEmailSynced(email);
      })
      .catch(function (error) {
        console.warn('[Klaviyo] wishlist list subscription failed', error);
      });
  }

  function syncEmailToKlaviyo(email, modal) {
    const config = getKlaviyoConfig(modal);
    if (!config || !config.enabled || !email) return;

    const properties = buildKlaviyoWishlistProperties(modal);

    callKlaviyo('identify', {
      email: email,
      $source: 'Product Wishlist Modal'
    });
    callKlaviyo('track', 'Added to Wishlist', properties);

    if (!hasKlaviyoSyncedEmail(email)) {
      subscribeEmailToKlaviyoList(email, config);
    }
  }

  function getPdpWishlistButton(event) {
    const triggerRoot = document.querySelector(TRIGGER_SELECTOR);
    if (!triggerRoot || !triggerRoot.contains(event.target)) return null;

    const button = event.target.closest(
      '.product__wishlist-btn, .swym-button-content, .swym-button-content button, .swym-button-content [role="button"], .swym-add-to-wishlist-view-product, .swym-button.swym-add-to-wishlist-view-product'
    );

    if (button) return button;

    return triggerRoot;
  }

  function bindPdpWishlistClick() {
    if (document.documentElement.dataset.pdpWishlistClickBound === 'true') return;
    document.documentElement.dataset.pdpWishlistClickBound = 'true';

    document.addEventListener(
      'click',
      function (event) {
        if (!getPdpWishlistButton(event)) return;

        const elements = getModalElements();
        if (!elements) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        handleWishlistClick(elements);
      },
      true
    );
  }

  function handleWishlistClick(elements) {
    const swat = getSwat();

    if (currentWishlistAdded) {
      return;
    }

    if (!shouldSkipEmailModal(swat, elements.modal)) {
      openModal(elements);
      return;
    }

    if (!swat) {
      console.error('[Swym] wishlist is not ready yet');
      return;
    }

    addProductToWishlist(elements.modal, function (error) {
      if (error) {
        console.error('[Swym] wishlist save failed', error);
        return;
      }

      completeWishlistAddSuccess(elements, getCustomerEmail(elements.modal));
    });
  }

  function bindModalUi() {
    const elements = getModalElements();
    if (!elements || elements.modal.dataset.wishlistModalUiBound === 'true') return;

    mountModalToBody(elements.modal);
    elements.modal.dataset.wishlistModalUiBound = 'true';

    bindPdpWishlistClick();

    elements.closeTargets.forEach(function (target) {
      target.addEventListener('click', function () {
        closeModal(elements);
      });
    });

    elements.modal.addEventListener('click', function (event) {
      if (
        event.target === elements.modal ||
        event.target.classList.contains('product-wishlist-modal__overlay')
      ) {
        closeModal(elements);
      }
    });

    if (elements.dialog) {
      elements.dialog.addEventListener('click', function (event) {
        event.stopPropagation();
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !elements.modal.hidden) {
        closeModal(elements);
      }
    });

    elements.form.addEventListener('submit', function (event) {
      event.preventDefault();

      const email = elements.emailInput.value.trim();
      if (!email) {
        elements.errorMessage.textContent = 'Please enter your email address.';
        elements.errorMessage.hidden = false;
        return;
      }

      if (!isValidEmail(email)) {
        elements.errorMessage.textContent = 'Please enter a valid email address.';
        elements.errorMessage.hidden = false;
        return;
      }

      const swat = getSwat();
      if (!swat || typeof swat.saveShopperContext !== 'function') {
        elements.errorMessage.textContent = 'Wishlist is still loading. Please try again.';
        elements.errorMessage.hidden = false;
        return;
      }

      const defaultSubmitLabel = elements.submitButton.textContent;
      elements.submitButton.disabled = true;
      elements.submitButton.textContent = 'Saving...';
      elements.errorMessage.hidden = true;
      elements.errorMessage.textContent = '';

      const userConfig = {
        src: 'wlreminder',
        app: 'Wishlist',
        skipConnect: false
      };

      swat.saveShopperContext(
        email,
        userConfig,
        function onSuccess() {
          addProductToWishlist(elements.modal, function (error) {
            elements.submitButton.disabled = false;
            elements.submitButton.textContent = defaultSubmitLabel;

            if (error) {
              elements.errorMessage.textContent = error.message || 'Something went wrong. Please try again.';
              elements.errorMessage.hidden = false;
              return;
            }

            markGuestEmailCaptured(email);
            completeWishlistAddSuccess(elements, email);
          });
        },
        function onError(error) {
          elements.submitButton.disabled = false;
          elements.submitButton.textContent = defaultSubmitLabel;
          elements.errorMessage.textContent =
            (error && error.message) || 'Could not save your email. Please try again.';
          elements.errorMessage.hidden = false;
        }
      );
    });

    document.querySelector('.product-form input.product-variant-id')?.addEventListener('change', function () {
      syncWishlistButtonState(elements.modal);
    });
  }

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(function (swat) {
    swatApi = swat;

    const elements = getModalElements();
    if (!elements) return;

    setWishlistSlotReady(true);
    syncLoggedInCustomer(swat, elements.modal);
    syncWishlistButtonState(elements.modal);
    bindPdpWishlistClick();

    window.setTimeout(function () {
      syncWishlistButtonState(elements.modal);
    }, 150);

    window.setTimeout(function () {
      syncWishlistButtonState(elements.modal);
    }, 600);

    if (swat.evtLayer && swat.JSEvents && swat.JSEvents.variantChanged) {
      swat.evtLayer.addEventListener(swat.JSEvents.variantChanged, function () {
        syncWishlistButtonState(elements.modal);
      });
    }

    if (swat.evtLayer) {
      swat.evtLayer.addEventListener('sw:addedtowishlist', function () {
        syncWishlistButtonState(elements.modal);
        notifyWishlistChanged();
      });
      swat.evtLayer.addEventListener('sw:removedfromwishlist', function () {
        syncWishlistButtonState(elements.modal);
        notifyWishlistChanged();
      });
    }
  });

  bindModalUi();
  bindPdpWishlistClick();
  setWishlistSlotReady(false);

  if (window._swat) {
    swatApi = window._swat;
    setWishlistSlotReady(true);

    const elements = getModalElements();
    if (elements) {
      syncLoggedInCustomer(window._swat, elements.modal);
      syncWishlistButtonState(elements.modal);
    }
  }

  window.setTimeout(function () {
    if (!getSwat()) {
      setWishlistSlotReady(false);
    }
  }, 10000);
})();
